import React from 'react';
import { withStyles, Grid, TableRow, TableCell, Typography, } from '@material-ui/core';

class MBasketTableItem extends React.Component {

    render() {
        const { classes, title, subtitle, midtitle, score1, score2, backgroundColor } = this.props;
        return (
            <Grid container direction='row' alignItems='center' justify='space-between' style={{ width: '100%', paddingTop: 8, paddingBottom: 8, backgroundColor: backgroundColor ? backgroundColor : '#FFF' }}>
                <Grid container direction='row' alignItems='center' justify='flex-start' style={{ flex: 1, maxWidth: '36%' }} >
                    <Typography className={classes.tableCell} style={{ marginLeft: 8, color: '#0D0D0D' }} >{title}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justify='center' style={{ maxWidth: '28%' }}>
                    <Typography className={classes.tableCell} style={{ color: '#FC2E34', textAlign: 'right' }}>{score1}</Typography>
                    <Typography className={classes.tableCell} style={{ marginLeft: 8, marginRight: 8, color: '#878787' }}>{midtitle}</Typography>
                    <Typography className={classes.tableCell} style={{ color: '#368CF4', textAlign: 'left' }}>{score2}</Typography>
                </Grid>
                <Grid container direction='row' alignItems='center' justify='flex-end' style={{ flex: 1, maxWidth: '36%' }} >
                    <Typography className={classes.tableCell} style={{ marginRight: 8, color: '#0D0D0D' }} >{subtitle}</Typography>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles((theme) => ({
    tableRow: {
        padding: theme.spacing(0, 0, 0, 0),
    },
    tableCell: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        fontSize: 11,
    }

}))(MBasketTableItem);